import { render, staticRenderFns } from "./SectionContact.vue?vue&type=template&id=6a5ef276&scoped=true&"
import script from "./SectionContact.vue?vue&type=script&lang=ts&"
export * from "./SectionContact.vue?vue&type=script&lang=ts&"
import style0 from "./SectionContact.vue?vue&type=style&index=0&id=6a5ef276&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a5ef276",
  null
  
)

export default component.exports